import { motion } from "framer-motion";
import { Parallax, EASE } from "./Motion";

const BLOB = "https://customer-assets-39nsmqrw.emergentagent.net/job_deck-elite-1/artifacts/kp69c139_AdobeStock_678572937.webp";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};
const line = {
  hidden: { y: "115%" },
  show: { y: "0%", transition: { duration: 1, ease: EASE } },
};

const BLOB_INITIAL = { opacity: 0, scale: 1.18, rotate: -6 };
const BLOB_IN_VIEW = { opacity: 1, scale: 1, rotate: 0 };
const BLOB_VIEWPORT = { once: true, margin: "-12%" };
const BLOB_TRANSITION = { duration: 1.5, ease: EASE };
const WORDMARK_VIEWPORT = { once: true, margin: "-15%" };

export default function TemplateIntro() {
  return (
    <section
      className="relative min-h-[68vh] md:min-h-[72vh] flex items-center"
      data-testid="template-intro"
    >
      {/* Iridescent blob — parallax drift + scale/fade reveal */}
      <Parallax
        range={70}
        className="absolute left-1/2 md:left-[-5%] top-[8%] md:top-1/2 -translate-x-1/2 md:translate-x-0 md:-translate-y-1/2 w-[92vw] md:w-[68vw] max-w-[1050px] pointer-events-none z-0"
      >
        <motion.img
          src={BLOB}
          alt="Iridescent 3D form"
          initial={BLOB_INITIAL}
          whileInView={BLOB_IN_VIEW}
          viewport={BLOB_VIEWPORT}
          transition={BLOB_TRANSITION}
          className="w-full h-auto max-h-[56vh] md:max-h-[62vh] object-contain select-none"
          draggable="false"
        />
      </Parallax>

      {/* Wordmark — staggered masked line reveal */}
      <div className="absolute inset-0 z-10 flex items-end md:items-center justify-center md:justify-end pointer-events-none">
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={WORDMARK_VIEWPORT}
          className="font-display text-white/85 leading-[0.95] text-center md:text-left pb-[10vh] md:pb-0 md:pr-[10vw]"
        >
          <span className="reveal-line">
            <motion.span variants={line} className="block font-black text-[16vw] md:text-[11vw] tracking-tight">
              Tem
            </motion.span>
          </span>
          <span className="reveal-line">
            <motion.span variants={line} className="block font-black text-[16vw] md:text-[11vw] tracking-tight">
              plate
            </motion.span>
          </span>
          <span className="reveal-line">
            <motion.span variants={line} className="block font-normal text-[10vw] md:text-[6.5vw] tracking-tight mt-[2vw] md:mt-[1.2vw]">
              Work
            </motion.span>
          </span>
        </motion.div>
      </div>
    </section>
  );
}
